import { useEffect, useState } from "react";

import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";

import { Button } from "@mui/material";
import { PageContainer } from "@/features/ui";

import { OutletRoleEnum } from "@/features/outlets";
import { PurchaseDownPaymentForm } from "@/features/purchase-down-payments";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { CenteredLoading, useSnackbar } from "@/features/ui";

export const EditPurchaseDownPayment = () => {
  const { referenceNumber } = useParams();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    const fetchPurchaseDownPayment = async () => {
      setIsLoading(true);
      try {
        const {
          data: { data },
        } = await apiOutletClient.get(
          `purchase-down-payments/${referenceNumber}`,
          {
            params: {
              withBuyer: true,
              withSeller: true,
              withPaymentTerm: true,
              withPurchaseOrder: true,
            },
          },
        );

        setDefaultValues({
          buyer: data.buyer,
          seller: data.seller,
          sellerableType:
            data.buyer?.role === OutletRoleEnum.HUB ? "SUPPLIER" : "OUTLET",
          purchaseOrder: data.purchaseOrder,
          transactionDate: dayjs(data.transactionDate),
          amount: data.amount ?? data.grandTotal,
          paymentTerm: data.paymentTerm,
          note: data.note ?? "",
        });
      } catch (error) {
        showSnackbar(
          getErrorMessage(error, "Gagal memperbarui uang muka pembelian"),
        );
      } finally {
        setIsLoading(false);
      }
    };
    fetchPurchaseDownPayment();
  }, [referenceNumber, showSnackbar]);

  const handleSubmit = async (formData) => {
    try {
      const { buyerId, transactionDate, amount, paymentTermId, note } =
        formData;

      await apiOutletClient.patch(
        `purchase-down-payments/${referenceNumber}`,
        { transactionDate, amount, paymentTermId, note },
        {
          headers: {
            "Outlet-Id": buyerId,
          },
        },
      );
      navigate(-1);
    } catch (error) {
      const errorMessage =
        getErrorMessage(error, "Gagal memperbarui uang muka pembelian");
      showSnackbar(errorMessage);
    }
  };

  if (!defaultValues && isLoading) {
    return <CenteredLoading />;
  }

  return (
    <PageContainer
      maxWidth="xl"
      title="Ubah Uang Muka Pembelian"
      breadcrumbs={[
        {
          title: "Uang Muka Pembelian",
          path: "/procurement/purchase-down-payments",
        },
        {
          title: referenceNumber,
          path: `/procurement/purchase-down-payments/${referenceNumber}`,
        },
        { title: "Ubah" },
      ]}
    >
      <PurchaseDownPaymentForm
        editMode
        isLoading={isLoading}
        defaultValues={defaultValues}
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button type="submit" variant="contained" loading={isSubmitting}>
            Simpan
          </Button>
        )}
      />
    </PageContainer>
  );
};
